import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const SchedulesRBAC = {
  pageID: 'b77b22963d21dcca872bfe67ce95d307',
  elementID: {
    ViewScheduleList: 'b52e521a5fe766e183c40da37decf243',
    ExportSchedule: '800dc399a12f4c0d3993e41d460e7ede',
    BulkUploadSchedule: 'be4f6544f6098f2c9d979d39cf946eeb',
    SingleEditSchedule: '9266341105ba6f66c608cc681e065adc',
    CreateUpdateOvertime: '5097c12cd73271c2d1f2c2acc3da61bd',
    UpdateOffDay: 'f5094fd483b755123be2775dcc4a4f03',
    AccessAllLocations: '53945828dc8d1a56b8caead4b370183e',
  },
} as const
export const useRBACSchedulesPage = createUseRBAC(SchedulesRBAC.elementID)
export type UseRBACSchedulesPageType = ReturnType<typeof useRBACSchedulesPage>

export const BulkUploadSchedulesRBAC = {
  pageID: 'e30da19e24e28f35bd367bee2931596c',
  elementID: {
    ViewPage: '805183771343c5ab2e4164e8d501567c',
    AccessAllLocations: '1db57aec4324c0ee30c50fffcee60875',
  },
} as const
export const useRBACBulkUploadSchedulesPage = createUseRBAC(BulkUploadSchedulesRBAC.elementID)
export type UseRBACBulkUploadSchedulesPageType = ReturnType<typeof useRBACBulkUploadSchedulesPage>

export const MasterApprovalRBAC = {
  pageID: 'd32ee4351f14cbed389a8fe99b8f327a',
  elementID: {
    ViewApprovalList: 'eaeaf0577b9f0bdbb32b6b288abdae94',
    SubmitApprovalAsApprover: 'd0fff64785c71bc0f70699033437c6a8',
    SubmitApprovalAsRequester: '1c31926c09ff26d4865ae5e1b62731f7',
    SubmitApprovalAsHR: '5a7aaae402b80eb44e65d6e75dd113ad',
    SubmitApprovalAsSPV: '3c4e17b8ed7a17dc774f6eb070508980',
    SubmitApprovalAsManager: '91e4b8b4b19f1bb8485ba7d5056e976c',
  },
} as const

export const useRBACMasterApprovalPage = createUseRBAC(MasterApprovalRBAC.elementID)
export type UseRBACMasterApprovalPageType = ReturnType<typeof useRBACMasterApprovalPage>

export const MasterShiftRBAC = {
  pageID: '44c50e099b0baa1b2f62ed76147f0785',
  elementID: {
    ViewShiftList: '873a0c4314e6d7abdc12b47ed6e068ea',
    CreateShift: '7a1ee02fb6f02c9f602bba9f6191eda7',
    EditShift: '157c0c8910705b1a9fa356b138760093',
  },
} as const

export const useRBACMasterShiftPage = createUseRBAC(MasterShiftRBAC.elementID)
export type UseRBACMasterShiftPageType = ReturnType<typeof useRBACMasterShiftPage>

export const AttendanceRBAC = {
  pageID: '3fe6e32bb2b8073c4562a13db4653bbd',
  elementID: {
    ViewAttendanceList: 'a44f901fc61de8d16ae232ad02dd79e7',
    ExportAttendance: '7e0559cf91fecdf23beacbd756b5d856',
    SingleEditAttendance: 'e4ea40eddc2e48b13722a47754079454',
    SingleEditAttendanceWithoutRules: '9a1153612236852ba1d186323a8af7f5',
    AccessAllLocations: 'a9023673669cd9c6bef90161e4156058',
    ForceCheckOutAttendance: '8f8d9289f24d8355e6dba7f4ce95784f',
    ExtendForceCoBufferAttendance: 'beef16dac98b38f961fb4154f668586a',
  },
} as const
export const useRBACAttendancePage = createUseRBAC(AttendanceRBAC.elementID)
export type UseRBACAttendancePageType = ReturnType<typeof useRBACAttendancePage>

export const OJTSlottingRBAC = {
  pageID: 'b33e5450f9fbfbefd06779018d0c6de2',
  elementID: {
    ViewOJTSlotting: '7495fe7a2ad1349ebf4255c27441ba6a',
    SetOffDay: '8413400ecdd5e2cff77e12e20193c195',
    UpsertOJTSlotting: '8d988bdc93369285809007a955cd115c',
  },
} as const
export const useRBACOJTSlottingPage = createUseRBAC(OJTSlottingRBAC.elementID)
export type UseRBACOJTSlottingPageType = ReturnType<typeof useRBACOJTSlottingPage>
